import React, { Component } from "react";
import { Container, Image } from "semantic-ui-react";
import Swiper from "react-id-swiper";
import drillt from "../../static/drillt_frau_waller_welt_2.jpg";

class Events extends Component {
  render() {
    const params = {
      spaceBetween: 10,
      effect: "fade"
    };

    return (
      <Container id="Events" className="main_content">
        <h1>Events & Angebote</h1>
        <h3>15.06 - 01.09 Lady for free</h3>
        <Swiper {...params}>
          <Image src={drillt} />
        </Swiper>
      </Container>
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/Events/index.js